module.exports = __webpack_public_path__ + "static/Об утверждении положения о кадровом резерве на ГГС РС(Я) (ред от 14_08_2017).doc";